module.exports = __webpack_public_path__ + "static/media/hero.df829f43.jpg";